<span (click)="openDialogDetailGuide()">
  &nbsp;<i class="fas fa-eye color-primary cursor-pointer" matTooltip="Ver detalle" matTooltipPosition="above"></i>
</span>